import { create } from "zustand";

// Stato del Centro guide: il pulsante "?" (in PageHeader) apre il dialog
// renderizzato da HelpCenter (montato nel Layout).
interface HelpState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useHelpStore = create<HelpState>((set) => ({
  open: false,
  setOpen: (open) => set({ open })
}));
